var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAudit = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-2,9A2,2,0,0,0,0,7V2A2,2,0,0,0-2,0H-4A2,2,0,0,0-6,2V7A2,2,0,0,0-4,9Z",
    transform: "translate(14 13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-2,12a2,2,0,0,0,2-2V2A2,2,0,0,0-2,0H-4A2,2,0,0,0-6,2v8a2,2,0,0,0,2,2Z",
    transform: "translate(22 10)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,3A3,3,0,0,0-3,0,3,3,0,0,0-6,3,3,3,0,0,0-3,6,3,3,0,0,0,0,3Z",
    transform: "translate(22 2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,3A3,3,0,0,0-3,0,3,3,0,0,0-6,3,3,3,0,0,0-3,6,3,3,0,0,0,0,3Z",
    transform: "translate(14 6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,3A3,3,0,0,0-3,0,3,3,0,0,0-6,3,3,3,0,0,0-3,6,3,3,0,0,0,0,3Z",
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-2,6.959a1,1,0,0,0,1,1,1,1,0,0,0,1-1V2A2,2,0,0,0-2,0H-4A2,2,0,0,0-6,2v9.959a2,2,0,0,0,2,2h2a2,2,0,0,0,2-2v-1a1,1,0,0,0-1-1,1,1,0,0,0-1,1v1H-4V2h2Z",
    transform: "translate(6 8)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,3.724-.891,1.933l-4.013,2,.89,1.791Zm-6.884.27L-12.87,0l-1.111,1.664,5.987,3.993Z",
    transform: "translate(17.56 3.185)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAudit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/audit.6e3a96e6.svg";
export { ForwardRef as ReactComponent };